module.exports = __webpack_public_path__ + "img/BQ.5b8993ee.svg";